import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppIconButton } from '@/UI/Buttons/AppIconButton';
import { FlexCenVer } from '@/UI/styles';
import { CaretIcon } from '@/UI/Icons';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';

interface BatchNavigationProps {
  batchNumber: number;
  totalBatches: number;
  onPrevious: () => void;
  onNext: () => void;
}

export const BatchNavigation = ({ batchNumber, totalBatches, onPrevious, onNext }: BatchNavigationProps) => {
  const { t } = useTranslation();
  return (
    <FlexCenVer sx={{ gap: 1, width: 'fit-content' }}>
      <AppIconButton onClick={onPrevious} width={32} height={32} mode="on-light">
        <CaretIcon style={{ height: '16px', width: '16px', transform: 'rotate(90deg)' }} />
      </AppIconButton>
      <Typography variant="body-std-rg" color={color.White80_T}>
        {t(I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.OVERLAY.BATCH)} {batchNumber} / {totalBatches}
      </Typography>
      <AppIconButton onClick={onNext} width={32} height={32} mode="on-light">
        <CaretIcon style={{ height: '16px', width: '16px', transform: 'rotate(-90deg)' }} />
      </AppIconButton>
    </FlexCenVer>
  );
};
